import React from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import SubregionList from '../SubregionList';
import HeaderBar from './HeaderBar';
import ApplyToShipperBar from './ApplyToShipperBar';
import { subregionReadiness } from './utils';

const SubregionsColumn = ({
    deliveryProfileId,
    onBack,
    onSelectProfile,
    onEditProfile,
    onCreateProfile,
    onAddSubregion,
    onSelectSubregion,
    state,
    loading,
    callbacks,
}) => (
    <Grid
        container
        direction="column"
        css={css`
            flex: 0;
            flex-basis: 0;
            flex-wrap: nowrap;
            min-width: 360px;
            max-width: 360px;
            /* Scroll instead of stretching the row (and the map). */
            min-height: 0;
            overflow-y: auto;
            border-right: 1px solid ${colors.greys[0]};
        `}
    >
        <HeaderBar
            deliveryProfileId={deliveryProfileId}
            deliveryProfiles={state.deliveryProfiles}
            name={state.deliveryProfile?.name}
            onSelect={onSelectProfile}
            onBack={onBack}
            onEdit={onEditProfile}
            // Edit reads the loaded profile, so it has to wait for it -- see HeaderBar.
            editDisabled={loading?.init || !state.deliveryProfile}
            onCreate={onCreateProfile}
        />
        {/* Disabled, not hidden, with no profile (per the designs). */}
        <ApplyToShipperBar
            shippers={state.shippers}
            deliveryProfileId={deliveryProfileId}
            deliveryProfile={state.deliveryProfile}
            // Attach needs the loaded profile's assign_zip_type.
            disabled={loading?.init || !deliveryProfileId}
            assignmentsByShipper={state.assignmentsByShipper}
            applyToShipper={callbacks.applyToShipper}
            onSuccess={() => callbacks.setNotification({ severity: 'success', message: 'Profile applied to shipper' })}
        />
        <SubregionList
            options={{
                enableAddSubregions: !!deliveryProfileId,
                enableImport: !!deliveryProfileId,
                enableExport: !!deliveryProfileId,
                showCarrierStatus: true,
                readiness: (subregion) => subregionReadiness(subregion, state.carriersById),
            }}
            loading={loading}
            filter={state.filter}
            selected={state.selectedSubregion}
            subregions={state.subregions}
            // Selection and Add go through the panel's unsaved-changes guard.
            callbacks={{ ...callbacks, onAddSubregion, toggleSubregion: onSelectSubregion }}
        />
    </Grid>
);

export default SubregionsColumn;
